import { toParagraph } from '../../base/BaseSchema';
import { hType } from './utils';
export const resetHeading = (state, dispatch, view) => {
    const { selection } = state;
    if (selection.empty &&
        selection.$from.parent.type === hType(state.schema) &&
        (view === null || view === void 0 ? void 0 : view.endOfTextblock('backward', state))) {
        return toParagraph(state, dispatch, view);
    }
    return false;
};
